import { render } from "./CategoriaNegocio.vue?vue&type=template&id=69ad299b&scoped=true"
import script from "./CategoriaNegocio.vue?vue&type=script&lang=js"
export * from "./CategoriaNegocio.vue?vue&type=script&lang=js"

import "./CategoriaNegocio.vue?vue&type=style&index=0&id=69ad299b&scoped=true&lang=css"

import exportComponent from "C:\\Users\\marce\\OneDrive\\Área de Trabalho\\Nova pasta (4)\\NoroesteRural 10.25.13\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69ad299b"]])

export default __exports__